import { Button, ButtonProps, Form } from 'antd';
import React, { useContext } from 'react';

import Paragraph from 'components/atoms/Paragraph';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

interface IButtonComponent extends ButtonProps {
    buttontext?: string;
    icon?: React.ReactNode;
    htmlType?: 'button' | 'submit' | 'reset';
    loading?: boolean;
    extramessage?: string;
    type?: 'text' | 'link' | 'primary' | 'default' | 'dashed' | undefined;
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    id?: string;
    disableEdit?: boolean;
    className?: string;
}

const ButtonComponent: React.FC<IButtonComponent> = props => {
    const { serviceMode } = useContext(Context);
    const {
        buttontext,
        icon,
        htmlType = 'button',
        type = 'primary',
        loading,
        extramessage,
        onClick,
        id,
        disableEdit,
        className
    } = props;

    return (
        <Form.Item
            extra={extramessage ? <Paragraph text={extramessage} className="extramessage-text" /> : null}
            style={{
                maxWidth: 650
            }}
            className={className}
        >
            <Button
                {...props}
                type={type}
                icon={icon}
                onClick={event => {
                    (!serviceMode || disableEdit) && onClick && onClick(event);
                }}
                htmlType={htmlType}
                loading={loading}
                id={id}
                style={{
                    borderRadius: 6,
                    ...props.style
                }}
            >
                <span
                    style={
                        icon
                            ? {
                                  paddingLeft: 6
                              }
                            : {}
                    }
                >
                    {buttontext && (
                        <TranslateText onClick={onClick} disableEdit={disableEdit}>
                            {buttontext}
                        </TranslateText>
                    )}
                </span>
            </Button>
        </Form.Item>
    );
};

export default ButtonComponent;
